import { Component, OnInit } from "@angular/core";
import {
  DatoPaginadoModel,
  Paging,
} from "src/app/shared/models/dato-paginado.model";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { RntService } from "../../../../../containers/bandeja-principal/funcionario/rnts/rnt.service";
import { ExentoService } from "./exento.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalConfirmarRespuestaComponent } from "src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component";
import {ConfirmarRespuestaModel
        ,ConfirmarRespuestaType,
      TipoConfirmacionModalType,
      } from "src/app/shared/models/confirmar-respuesta.model";
import { ModalGenerarAyudaComponent } from 'src/app/components/core/layouts/modal-generar-ayuda/modal-generar-ayuda.component';
import { AuthService } from "src/app/shared/services/auth.service";
import { RolesUsuario } from "src/app/shared/enumeraciones/roles-usuario.enum";
import { CamaraComercioEntry } from "src/app/shared/entrys/camara-comercio";
import { DepartamentoEntry } from "src/app/shared/entrys/departamento.entry";
import { MunicipioEntry } from "src/app/shared/entrys/municipio.entry";
import { CategoriaEntry } from "src/app/shared/entrys/categoria.entry";
import { CampoAdicionalCategoriaService } from "../../configuracion/campo-adicional-categoria/campo-adicional-categoria.service";
import { SubCategoriaEntry } from "src/app/shared/entrys/sub-categoria.entry";
import { DocumentoSubcategoriaService } from "../../configuracion/documento-subcategoria/documento-subcategoria.service";
import { EstablecimientoComercioService } from "../../../prestador/establecimiento-comercio/establecimiento-comercio.service";
import { ReportesEstablecimientosService } from "../../reportes/establecimientos/reportes-establecimientos.service";
import { BasicasLoVService } from "src/app/shared/services/basicas-lov.service";
import { RntExcentosModel } from "src/app/shared/models/rnt-excentos.model";
import { AlertsService } from 'src/app/shared/services/alerts.service';



@Component({
  selector: "app-exento",
  templateUrl: "./exento.component.html",
  styleUrls: ["./exento.component.scss"],
})
export class ExentoComponent implements OnInit {
  dataTabla: DatoPaginadoModel;
  dataTablaAux: DatoPaginadoModel;

  headerExentos: Array<string>;
  formExentos: FormGroup;
  selectExento: any;
  paginaActual: number;

  categoria: Array<CategoriaEntry> = [];
  subcategoria: Array<SubCategoriaEntry> = [];
  departamento: Array<DepartamentoEntry> = [];
  municipio: Array<MunicipioEntry> = [];

  tipo_funcionario = RolesUsuario.Funcionario;
  adminSuper = RolesUsuario.AdministradorSuper;
  soloConsultaNacional = RolesUsuario.SoloConsultaNacional;
  adminCC = RolesUsuario.AdministradorCC;

  userLogin: boolean;
  camarasLista: Array<CamaraComercioEntry>;

  // filtros
  formfiltro: FormGroup;
  public isCollapsed = true;

  headerTablaExentos: Array<string>;

  categoriafil: Array<CategoriaEntry> = [];
  subcategoriafil: Array<SubCategoriaEntry> = [];
  departamentofil: Array<DepartamentoEntry> = [];
  municipiofil: Array<MunicipioEntry> = [];
  camarasListafil: Array<CamaraComercioEntry>;

CodeUseCamara: any;


 formExentoData: RntExcentosModel;
 formExentoFiltroData: RntExcentosModel;

  constructor(
    private formBuilder: FormBuilder,
    private exentoService: ExentoService,
    private modalService: NgbModal,
    private rntService: RntService,
    public authService: AuthService,
    private reportesEstablecimientos: ReportesEstablecimientosService,
    private establecimientoComercioService: EstablecimientoComercioService,
    private subcategoriaService: DocumentoSubcategoriaService,
    private categoriaService: CampoAdicionalCategoriaService,
    private basicasLoVService: BasicasLoVService,
    private alertService: AlertsService
  ) {
    this.dataTabla = {
      paging: {} as Paging,
    } as DatoPaginadoModel;


    this.dataTablaAux = {
      paging: {} as Paging,
    } as DatoPaginadoModel;

    this.userLogin = authService.isToken();
    this.createForm();
    this.selectExento = null;
    this.paginaActual = 1;
  }

  ngOnInit(): void {

    this. onGetUsuarioCamra();

    this.onCamaraSelect();
    this.onCategoriaSelect();
    this.onSubcategoriaSelect();
    this.onDepartamentosSelect();
    this.onMunicipioSelect();

    this.onCamaraSelectFiltro();
    this.onCategoriaSelectFiltro();
    this.onSubcategoriaSelectFiltro();
    this.onDepartamentosSelectFiltro();
    this.onMunicipioSelectFiltro();

    this.headerTablaExentos = ['Número RNT','Camara','Nombre ó Razon social','NIT','Categoria','Sub Categoria','Departamento','Municipio','Descripcion','usuario creo','Fecha creacion excepción','Fecha fin excepción','usuario actualizo','Fecha última actualización','Estado exepción','Acción']
    this.onConsultarRntsExentos(1);


  }

  // definicion de validacion formulario
  createForm() {

    this.formExentos = this.formBuilder.group({
      codigo_rnt: [null, Validators.required],
      codigo_camara: [null, Validators.required],
      razon_social: [null, Validators.required],
      nit: [null, Validators.required],
      categoria: [null, Validators.required],
      sub_categoria: [null, Validators.required],
      codigo_departamento: [null, Validators.required],
      municipio_id: [null, Validators.required],
      descripcion_excepcion: [null, Validators.required],
      fecha_excepcion: [null, Validators.required],
      activo: [null]
    });

    this.formfiltro = this.formBuilder.group({
      codigo_camara: [null],
      numeroRNT: [null],
      nit: [null],
      razonSocial: [null],
      categoria: [null],
      subcategoria: [null],
      departamentoComercial: [null],
      municipioComercial: [null]
    });
  }

  // Consultar lsita exetos
  onConsultarRntsExentos(page: number) {

    this.formExentoFiltroData={
      codigo_camara: this.CodeUseCamara === null ||  this.CodeUseCamara === undefined ? this.formfiltro.controls['codigo_camara'].value :this.CodeUseCamara
      ,codigo_rnt: this.formfiltro.controls['numeroRNT'].value
      ,razon_social: this.formfiltro.controls['razonSocial'].value
      ,nit: this.formfiltro.controls['nit'].value
      ,categoria_id:this.formfiltro.controls['categoria'].value
      ,sub_categoria_id:this.formfiltro.controls['subcategoria'].value
      ,codigo_departamento: this.formfiltro.controls['departamentoComercial'].value
      ,codigo_municipio: this.formfiltro.controls['municipioComercial'].value
    }
  // console.log('Dato filtro',this.formExentoFiltroData);

    this.exentoService.GetListaExentos(page,this.formExentoFiltroData)
    .subscribe(resultado => {
    		if (resultado.result) {
    			this.dataTabla = resultado.data as DatoPaginadoModel;
          // console.log('Datos de la tabla:', this.dataTabla);
    		}
    	});
  }

  // control paginacion
  onPaginado(value: number) {
    this.paginaActual = value;
    this.onConsultarRntsExentos(value);
  }

  // agregar registro para definir rnts extensos
  onAgregarParametro() {
    if (this.formExentos.valid){

      this.formExentoData={
        codigo_camara: this.formExentos.controls['codigo_camara'].value
        ,codigo_rnt: this.formExentos.controls['codigo_rnt'].value
        ,razon_social: this.formExentos.controls['razon_social'].value
        ,nit: this.formExentos.controls['nit'].value
        ,categoria_id:this.formExentos.controls['categoria'].value
        ,sub_categoria_id:this.formExentos.controls['sub_categoria'].value
        ,codigo_departamento: this.formExentos.controls['codigo_departamento'].value
        ,codigo_municipio: this.formExentos.controls['municipio_id'].value
        ,descripcion_excepcion: this.formExentos.controls['descripcion_excepcion'].value
        ,fecha_aplica_excepcion: this.formExentos.controls['fecha_excepcion'].value
        ,activo: this.formExentos.controls['activo'].value
      }

       this.exentoService.CreateExentos(this.formExentoData).subscribe(resultado => {
           if (resultado.result) {

               if(resultado.control.code == 409){
                this.alertService.warn(
                  resultado.control.message,
                  null,
                  null);

               }
              this.onConsultarRntsExentos(this.paginaActual);
             this.formExentos.reset();
           }else{
            console.log('Erro!!!!');
           }
         });
    } else{
      console.warn("El formulario no es válido.");
    }

  }

  // controlar boton para agregar o modificar registros
  onOperarParametroExento() {

    if (!this.selectExento) {
    	this.onAgregarParametro();
    } else {
    	this.onActualizarRegistro();
    }
  }

  onCargarRntExentoAEstudio(entry: any) {
    entry.activo = entry.activo ? 1 : 0;
    var code_rnt = entry.codigo_rnt;
    this.exentoService.GetListaExentos(1,{codigo_rnt:code_rnt})
    .subscribe(resultado => {
    		if (resultado.result) {
    			this.dataTablaAux = resultado.data as DatoPaginadoModel;


          const fechaExcepcion = this.dataTablaAux.items[0].fin_fecha_aplica_excepcion;
          const fechaFormateada = this.formatFechaParaInput(fechaExcepcion);


          this.formExentos.patchValue({

            codigo_rnt: this.dataTablaAux.items[0].codigo_rnt,
            codigo_camara: this.dataTablaAux.items[0].codigo_camara,
            razon_social: this.dataTablaAux.items[0].razon_social,
            nit: this.dataTablaAux.items[0].nit,
            categoria: this.dataTablaAux.items[0].categoria_id,
            sub_categoria: this.dataTablaAux.items[0].sub_categoria_id,
            codigo_departamento: this.dataTablaAux.items[0].codigo_departamento,
            municipio_id: this.dataTablaAux.items[0].codigo_municipio,
            descripcion_excepcion : this.dataTablaAux.items[0].descripcion_excepcion,
            activo :this.dataTablaAux.items[0].activo === true ? 1 : 0,
            fecha_excepcion:fechaFormateada

          });
    		}
    	});


    this.formExentos.get('codigo_rnt').disable();
    this.formExentos.get('codigo_camara').disable();
    this.formExentos.get('razon_social').disable();
    this.formExentos.get('nit').disable();
    this.formExentos.get('categoria').disable();
    this.formExentos.get('sub_categoria').disable();
    this.formExentos.get('codigo_departamento').disable();
    this.formExentos.get('municipio_id').disable();
    this.selectExento = entry;
  }

// Método para formatear la fecha
private formatFechaParaInput(fecha: string | Date): string {
  const date = new Date(fecha);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}`;
}



  onObtenerRNTexento(): void {
    const codigo_RNT = this.formExentos.get("codigo_rnt")?.value;

  // Verificar que el campo no esté vacío o nulo
  if (!codigo_RNT) {
    console.warn("El campo 'codigo_rnt' está vacío, no se realizará la búsqueda.");
    return; // No llamar al servicio si el campo está vacío
  }


    this.exentoService.GetRntExentoEstudioAutomatico(codigo_RNT).subscribe((resultado)=> {
       if(resultado){
        const dataAux = resultado.data;

        // Verificar si el código de cámara coincide



          if (this.CodeUseCamara != null && this.CodeUseCamara !== dataAux.codigo_camara ) {
            // alert("Este RNT no pertenece a su jurisdicción, por favor inténtelo nuevamente con uno que corresponda a su jurisdicción.");
            const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
            const confirmarRespuesta = {} as ConfirmarRespuestaModel;
            confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
            confirmarRespuesta.message = `Este RNT no pertenece a su jurisdicción, por favor inténtelo nuevamente con uno que corresponda a su jurisdicción.`;
            confirmarRespuesta.tipoConfirmacionModalType = TipoConfirmacionModalType.Alerta
            confirmarRespuesta.buttonTextAlert = "Aceptar";
            modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
            modalRef.result.then((result) => {
              if (result) {
                this.formExentos.reset();
              }
            });

            return; // Detener ejecución si no coincide
          }


        // Actualizar el formulario con los datos devueltos
        this.formExentos.patchValue({
          codigo_camara: dataAux.codigo_camara,
          razon_social: dataAux.razon_social,
          nit: dataAux.nit,
          categoria: dataAux.categoria_id,
          sub_categoria: dataAux.sub_categoria_id,
          codigo_departamento: dataAux.dpto_comercial,
          municipio_id: dataAux.municipio_comercial,
          descripcion_excepcion: dataAux.descripcion_exepcion,
          fecha_excepcion: dataAux.fecha_aplica_excepcion,
          activo:1
        });
      }

    });
  }



  onActualizarRegistro() {

    this.formExentoData={
       codigo_rnt: this.formExentos.controls['codigo_rnt'].value
      ,descripcion_excepcion: this.formExentos.controls['descripcion_excepcion'].value
      ,fecha_aplica_excepcion: this.formExentos.controls['fecha_excepcion'].value
      ,activo: this.formExentos.controls['activo'].value
    }


    this.exentoService.update(this.formExentoData)
    	.subscribe(resultado => {
    		if (resultado.result) {
          this.onConsultarRntsExentos(this.paginaActual);
          this.formExentos.reset();
          this.onRestearEstadoFormulario()
          this.selectExento = null;
    		}
    	});
  }

  //filtro
  filtrar() {
    this.paginaActual = 1;
    this.onConsultarRntsExentos(1);
  }

  Resetear() {
    this.formfiltro.reset();
    this.filtrar();
  }

  limpiarCampo() {

    if (this.selectExento) {
      this.onRestearEstadoFormulario();
      this.selectExento = null;
    }
    this.formExentos.reset();
    this.createForm();

  }



  onGetUsuarioCamra(){

    if (this.authService.getRolUser(RolesUsuario.AdministradorCC)) {
      this.CodeUseCamara = this.authService.getCamaraUser();
    }else{
      this.CodeUseCamara = null;
    }

  }

  onCamaraSelect() {
    this.establecimientoComercioService.getCamaras().subscribe((resultado) => {
      if (resultado) {
        this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
        if (this.authService.getRolUser(RolesUsuario.AdministradorCC)) {
          this.formExentos
            .get("codigo_camara")
            .patchValue(this.authService.getCamaraUser());
          this.onDepartamentosSelect();
        }
      }
    });
  }


  onDepartamentosSelect() {
    if (this.formExentos.value.codigo_camara == null) {
      this.basicasLoVService.getDepartamentos(null).subscribe((resultado) => {
        if (resultado.result) {
          this.departamento = resultado.data as Array<DepartamentoEntry>;
        }
      });
    } else {
      this.reportesEstablecimientos
        .getDepartamento({
          codigo_camara: this.formExentos.value.codigo_camara,
        })
        .subscribe((resultado) => {
          if (resultado.result) {
            this.departamento = resultado.data as Array<DepartamentoEntry>;
            this.onMunicipioSelect();
          }
        });
    }
  }

  onMunicipioSelect() {
    if (
      this.formExentos.value.codigo_camara == null &&
      this.formExentos.value.codigo_departamento == null
    ) {
      this.basicasLoVService.getMunicipios(null).subscribe((resultado) => {
        if (resultado.result) {
          this.municipio = resultado.data as Array<MunicipioEntry>;
        }
      });
    } else {
      // tslint:disable-next-line:max-line-length
      this.reportesEstablecimientos
        .getMunicipio({
          codigo_camara: this.formExentos.value.codigo_camara,
          departamento_id: this.formExentos.value.codigo_departamento,
        })
        .subscribe((resultado) => {
          if (resultado.result) {
            this.municipio = resultado.data as Array<MunicipioEntry>;
          }
        });
    }
  }


  onCategoriaSelect() {
    this.categoriaService.getCategoria().subscribe((resultado) => {
      if (resultado.result) {
        this.categoria = resultado.data;
      }
    });
  }

  onSubcategoriaSelect() {
    if (this.formExentos.value.categoria == null) {
      this.subcategoriaService.getSubCategoria().subscribe((resultado) => {
        if (resultado.result) {
          this.subcategoria = resultado.data;
        }
      });
    } else {
      this.reportesEstablecimientos
        .getSubcategoriasXCategoria(this.formExentos.value.categoria)
        .subscribe((resultado) => {
          if (resultado.result) {
            this.subcategoria = resultado.data;
          }
        });
    }
  }


  // metodos para formulario filtro

  onCamaraSelectFiltro() {
    this.establecimientoComercioService.getCamaras().subscribe((resultado) => {
      if (resultado) {
        this.camarasListafil = resultado.data as Array<CamaraComercioEntry>;
        if (this.authService.getRolUser(RolesUsuario.AdministradorCC)) {
          this.formfiltro
            .get("codigo_camara")
            .patchValue(this.authService.getCamaraUser());
          this.onDepartamentosSelectFiltro();
        }
      }
    });
  }

  onDepartamentosSelectFiltro() {
    if (this.formfiltro.value.codigo_camara == null) {
      this.basicasLoVService.getDepartamentos(null).subscribe((resultado) => {
        if (resultado.result) {
          this.departamentofil = resultado.data as Array<DepartamentoEntry>;
        }
      });
    } else {
      this.reportesEstablecimientos
        .getDepartamento({
          codigo_camara: this.formfiltro.value.codigo_camara,
        })
        .subscribe((resultado) => {
          if (resultado.result) {
            this.departamentofil = resultado.data as Array<DepartamentoEntry>;
            this.onMunicipioSelectFiltro();
          }
        });
    }
  }

  onMunicipioSelectFiltro() {
    if (
      this.formfiltro.value.codigo_camara == null &&
      this.formfiltro.value.departamentoComercial == null
    ) {
      this.basicasLoVService.getMunicipios(null).subscribe((resultado) => {
        if (resultado.result) {
          this.municipiofil = resultado.data as Array<MunicipioEntry>;
        }
      });
    } else {
      // tslint:disable-next-line:max-line-length
      this.reportesEstablecimientos
        .getMunicipio({
          codigo_camara: this.formfiltro.value.codigo_camara,
          departamento_id: this.formfiltro.value.departamentoComercial,
        })
        .subscribe((resultado) => {
          if (resultado.result) {
            this.municipiofil = resultado.data as Array<MunicipioEntry>;
          }
        });
    }
  }


  onCategoriaSelectFiltro() {
    this.categoriaService.getCategoria().subscribe((resultado) => {
      if (resultado.result) {
        this.categoriafil = resultado.data;
      }
    });
  }

  onSubcategoriaSelectFiltro() {
    if (this.formfiltro.value.categoria == null) {
      this.subcategoriaService.getSubCategoria().subscribe((resultado) => {
        if (resultado.result) {
          this.subcategoriafil = resultado.data;
        }
      });
    } else {
      this.reportesEstablecimientos
        .getSubcategoriasXCategoria(this.formfiltro.value.categoria)
        .subscribe((resultado) => {
          if (resultado.result) {
            this.subcategoriafil = resultado.data;
          }
        });
    }
  }

onRestearEstadoFormulario(){
  this.formExentos.get('codigo_rnt').enable();
  this.formExentos.get('codigo_camara').enable();
  this.formExentos.get('razon_social').enable();
  this.formExentos.get('nit').enable();
  this.formExentos.get('categoria').enable();
  this.formExentos.get('sub_categoria').enable();
  this.formExentos.get('codigo_departamento').enable();
  this.formExentos.get('municipio_id').enable();
}

}
